import { Heading } from '@kandji-inc/nectar-ui';
import type { ReactNode } from 'react';

type PageHeaderLevel1Props = {
  title: string | ReactNode;
  children?: ReactNode;
};
const PageHeaderLevel1 = (props: PageHeaderLevel1Props) => {
  return (
    <>
      <Heading as="h2" size="1">
        {props.title}
      </Heading>

      {props.children}
    </>
  );
};

export default PageHeaderLevel1;
